import type { Call } from '@entities/call';
import type { BaseUsecase } from '@usecases/base-usecase';

export type IdleCallRequest = void;

export interface IdleCallRepository {
  getCurrentCall(): Promise<Call>;
  removeCalls(): Promise<void>;
}

export interface IdleCallEventPublisher {
  publish(call: Call): Promise<void>;
}

export interface IdleCallUsecase extends BaseUsecase<IdleCallRequest, void> {
  run(call: IdleCallRequest): Promise<void>;
}

export class IdleCall implements IdleCallUsecase {
  constructor(
    private repository: IdleCallRepository,
    private publisher: IdleCallEventPublisher,
  ) {}

  async run(): Promise<void> {
    const call = await this.repository.getCurrentCall();

    if (call) {
      await Promise.all([
        this.publisher.publish(call),
        this.repository.removeCalls(),
      ]);
    }
  }
}
